app = angular.module("seismology")
ref = firebase.database().ref()


app.factory 'Chars', ($firebaseArray, $firebaseObject)->
  charsRef = ref.child('chars')

  getByLessonId: (lessonId) ->
    query = charsRef.orderByChild('lesson_id').equalTo(lessonId)
    $firebaseArray(query)

  get: (id) ->
    $firebaseObject(query = charsRef.child(id))

app.factory 'Lesson', (LessonProgress) ->
  lessons = [
    id: 'lesson-01'
    type: 'kana'
    title: '変体仮名 その１（あ〜か行）'
    img: 'resources/img/chars/ipa/586e63bec5efcbec52bc4ddf6f1fe679.png'
  ,
    id: 'lesson-02'
    type: 'kana'
    title: '変体仮名 その２（さ〜た行）'
    img: 'resources/img/chars/ipa/3b08ac60c20eed5dd7a3b981e9de32cf.png'
  ,
    id: 'lesson-03'
    type: 'kana'
    title: '変体仮名 その３（な〜は行）'
    img: 'resources/img/chars/ipa/495d6de66707c7ff395382b1d468ed86.png'
  ,
    id: 'lesson-04'
    type: 'kana'
    title: '変体仮名 その４（ま〜や行）'
    img: 'resources/img/chars/ipa/4c8f8f42b7a14f667774193d4ee348f7.png'
  ,
    id: 'lesson-05'
    type: 'kana'
    title: '変体仮名 その５（ら行〜ん）'
    img: 'resources/img/chars/ipa/727a873d36c01e372b819f51778b898c.png'
  ,
    id: 'lesson-06'
    type: 'kanji'
    title: '漢字 その１'
    img: 'resources/img/top/lesson06.jpg'
  ,
    id: 'lesson-07'
    type: 'kanji'
    title: '漢字 その２'    
    img: 'resources/img/top/lesson07.jpg'
  ,
    id: 'lesson-08'
    type: 'kanji'
    title: '漢字 その３'    
    img: 'resources/img/top/lesson08.jpg'
  ,
    id: 'lesson-09'
    type: 'kanji'
    title: '漢字 その４'    
    img: 'resources/img/top/lesson09.jpg'
  ,
    id: 'lesson-10'
    type: 'kanji'
    title: '漢字 その５'    
    img: 'resources/img/top/lesson10.jpg'
  ,
    id: 'lesson-11'
    type: 'kanji'
    title: '漢字 その６'   
    img: 'resources/img/top/lesson11.jpg'
  ,
    id: 'lesson-12'
    type: 'kanji'
    title: '漢字 その７'   
    img: 'resources/img/top/lesson12.jpg'
  ,
    id: 'lesson-13'
    type: 'kanji'
    title: '漢字 その８'    
    img: 'resources/img/top/lesson13.jpg'
  ,
    id: 'lesson-14'
    type: 'kanji'
    title: '漢字 その９'    
    img: 'resources/img/top/lesson14.jpg'
  ]

  getKanaLessons: ->
    lessons.filter (l) -> l.type is 'kana'

  getKanjiLessons: ->
    lessons.filter (l) -> l.type is 'kanji'

  get: (id) ->
    lesson = null
    for l in lessons
      lesson = l if l.id is id
    lesson

  getLessonCount: ->
    Object.keys(lessons).length


app.factory 'QuizArrayFactory', ($firebaseArray, $firebaseObject, Chars, DakutenConverter)->

  fisherYates = (arr) ->
    i = arr.length
    return arr unless i > 0
    while --i
        j = Math.floor(Math.random() * (i+1))
        [arr[i], arr[j]] = [arr[j], arr[i]] # use pattern matching to swap
    arr

  chooseRandom = (arr) ->
    index = Math.floor( Math.random() * arr.length)
    arr[index]

  generateAnswers = (char, quiz, askAllChars) ->
    answers = []
    if askAllChars
      # 頭1文字を除いた残り
      body = quiz.yomi.substr(1)
      odorijiRemoved = body.replace /(.)[ゝゞ]/g, (all, match)-> match
      answers = [body, odorijiRemoved]
    else
      # 「か（加）」のカッコ部分を除いた一文字
      singleChar = char.char.replace(/（.+）/g, '')
      # 「か」のときの「が」 or null
      dakuten = DakutenConverter.convert2Dakuten(singleChar)
      answers = [singleChar, dakuten]
    answers

  generateQuestionText = (char, quiz, askAllChars) ->
    text = ""
    if askAllChars
      # 頭1文字は表示する
      head = quiz.yomi[0]
      body = Array(quiz.yomi.length).join('■')
      text = head+body
    else
      singleChar = char.char.replace(/（.+）/g, '')
      text = quiz.yomi.replace(singleChar, "■")
      # e.g. 答えが「か」の時「あがり」のような用例を「あ■り」に直す
      dakuten = DakutenConverter.convert2Dakuten(singleChar)
      if dakuten
        text = text.replace(dakuten, "■")
    text

  $firebaseArray.$extend

    shuffle: ->
      @$list = fisherYates(@$list)
      @

    getQuizAt: (index, askAllChars=false) ->
      char = @$list[index]      
      examples = char['usecases_multi']
      quiz = chooseRandom(examples)
      quiz.char = char
      quiz.questionText = generateQuestionText(char, quiz, askAllChars)
      quiz.answers = generateAnswers(char, quiz, askAllChars)
      quiz
  
app.factory 'Quiz', ($sce, QuizArrayFactory, Chars) ->
  charsRef = ref.child('chars')

  getByLessonId: (lessonId, size = 10) ->
    query = charsRef.orderByChild('lesson_id').equalTo(lessonId)
    array = QuizArrayFactory(query)
    array.$loaded -> array.shuffle()
    array
      
  
app.factory 'QuizState', ->

  checkAnswer = (quiz) ->
    quiz.current.answers.indexOf(quiz.input) >= 0

  states = {
    asking:
      speech: (quiz) ->
        if quiz.askAllChars
          "■の部分は何て読むかな？<b>#{quiz.current.yomi.length-1}文字</b>で答えてね"
        else
          "■の文字は何て読むかな？<b>１文字</b>で答えてね"
          
      img: "./resources/img/shimimaru/04.png"
      input: true
      placeholder: '回答を入力'
      hideAnswer: true
      next: (quiz) ->
        if checkAnswer(quiz)
          quiz.correct += 1
          quiz.input = ""
          'correct'
        else
          quiz.input = ""
          'incorrect'
    correct:
      speech: (quiz) ->
        if quiz.askAllChars
          "正解！「<b>#{quiz.current.yomi}</b>」だね。"
        else
          "正解！「<b>#{quiz.current.char.char}</b>」だね。"
      img: "./resources/img/shimimaru/14.png"
      bgClass: "correct"
      next: (quiz) ->
        quiz.progress += 1        
        if quiz.progress >= quiz.size
          'finishing'
        else          
          quiz.current = quiz.quizArray.getQuizAt(quiz.progress, quiz.askAllChars)
          'asking'
    incorrect:
      speech: (quiz) ->
        if quiz.askAllChars
          "残念。正解は「<b>#{quiz.current.yomi}</b>」だよ。"
        else
          "残念。正解は「<b>#{quiz.current.char.char}</b>」だよ。"
      img: "./resources/img/shimimaru/05.png"
      bgClass: "incorrect"
      next: (quiz) ->
        quiz.progress += 1
        if quiz.progress >= quiz.size
          'finishing'
        else
          quiz.current = quiz.quizArray.getQuizAt(quiz.progress, quiz.askAllChars)
          'asking'
    finishing:
      speech: (quiz) -> "お疲れさま！ これでテストは終了だよ。今回の結果は…"
      waitFor : 2000
      img: "./resources/img/shimimaru/01.png"
      next: (quiz) ->
        correctRatio = quiz.correct/(quiz.size*1.0)
        if correctRatio == 1
          'resultPerfect'
        else if correctRatio >= 0.8
          'resultGood'
        else if correctRatio > 0.4
          'resultModerate'
        else
          'resultBad'
    resultPerfect:
      speech: (quiz) -> "<b>#{quiz.size}問全問正解</b>だ！ 完璧だね。"
      waitFor : 2000
      img: "./resources/img/shimimaru/02.png"
      next: (quiz) -> "end"
      isCleared: true
    resultGood:
      speech: (quiz) ->
        "<b>#{quiz.size}問中#{quiz.correct}問正解</b>。よくできました！"
      waitFor : 3000
      img: "./resources/img/shimimaru/14.png"
      next: (quiz) -> "end"
      isCleared: true
    resultModerate:
      speech: (quiz) ->
        "<b>#{quiz.size}問中#{quiz.correct}問正解</b>。まあまあだね。"
      waitFor : 3000
      img: "./resources/img/shimimaru/06.png"
      next: (quiz) -> "end"
    resultBad:
      speech: (quiz) ->
        "</b>#{quiz.size}問中#{quiz.correct}問正解</b>。もう少し頑張って、再挑戦してね！"
      waitFor : 3000
      img: "./resources/img/shimimaru/03.png"
      next: (quiz) -> "end"
    end:
      speech: (quiz) -> "テストを繰り返して、字形をしっかり覚えよう！"
      img: "./resources/img/shimimaru/13.png"
      showCloseButton: true
  }

  @state = states.asking

  getState: ->
    @state

  setState: (key) -> @state = states[key]

  proceed: (quiz) ->
    key = @state.next(quiz)
    @state = states[key]
    @state

  getSpeech: (quiz)->
    html = $sce.trustAsHtml(@state.speech(quiz))
    html

app.factory "DakutenConverter", () ->

  dakuten = "がぎぐけござじずぜぞだぢづでどばびぶべぼ"
  kana    = "かきくけこさしすせそたちつてとはひふへほ"

  convert2Kana: (char) ->
    kana.charAt(dakuten.indexOf(char))

  convert2Dakuten: (char) ->
    dakuten.charAt(kana.indexOf(char))

  isDakuten: (char) ->
    dakuten.indexOf(char) >= 0

app.factory 'LessonProgress', ($firebaseObject, $firebaseArray, CurrentUser, NotificationMsg) ->
  
  uid = CurrentUser.get().$id
  progressRef = ref.child('lesson-progress').child(uid)
  
  getList: ()->
    $firebaseArray(progressRef)

  getListOf: (uid) ->
    progressRef = ref.child('lesson-progress').child(uid)
    $firebaseArray(progressRef)

  get: (lessonId) ->
    $firebaseObject(progressRef.child(lessonId))
  
  setGemCount: (lessonId, count) ->
    progressRef.child(lessonId).transaction (currentCount) ->      
      if !currentCount or currentCount < count
        newCount = count
      else
        newCount = currentCount
      newCount

  getGemCount: ->
    @getList().$loaded().then (progressList)->
      gemCount = 0
      for l in progressList
        gemCount+= l.$value
      gemCount


app.factory "TutorialDialog", ($mdDialog) ->

  show: (number) ->
    speech = require("../data/learn_tutorial_#{number}.tsv")
    $mdDialog.show
      controller: 'TutorialDialogCtrl'
      parent: angular.element(document.body)
      clickOutsideToClose: true
      templateUrl: 'templates/dialogs/tutorial.html'
      locals:
        speech: speech
      



app.factory 'NotificationMsg', ($mdToast)->

  show: (msg) ->
    $mdToast.show
      hideDelay   : 3000
      position    : 'bottom right'
      templateUrl : 'templates/kula/message-toast.html'
      controller  : ($mdToast, $scope)->
        $scope.msg = msg





// WEBPACK FOOTER //
// ./app/services/learn_services.coffee